export function formatCurrency(value: number): string {
  return value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function formatWholeDollars(value: number): string {
  return `$${Math.floor(value).toLocaleString("en-US")}`;
}

export function formatSignedCurrency(value: number): string {
  return value < 0 ? `-$${formatCurrency(-value)}` : `$${formatCurrency(value)}`;
}

export function formatSignedWholeDollars(value: number): string {
  return value < 0 ? `-${formatWholeDollars(-value)}` : formatWholeDollars(value);
}

export function formatTransactionType({ type, amount, status }: { type: string; amount: number; status: string }): string {
  if (type === "BalanceTransfer") {
    if (status.toLowerCase() === "canceled") return `Scheduled transfer of $${formatCurrency(Math.abs(amount))}`;
    return amount > 0 ? "Transfer In" : "Transfer Out";
  }
  return type.replace(/([a-z])([A-Z])/g, "$1 $2");
}